document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('[data-systems-grid]');
  if (!grid) return;

  var drawer = grid.querySelector('[data-system-drawer]');
  var overlay = drawer.querySelector('[data-system-overlay]');
  var panelTarget = drawer.querySelector('[data-system-panel-target]');
  var closeBtn = drawer.querySelector('[data-system-close]');
  var triggers = grid.querySelectorAll('[data-system-trigger]');
  var lastFocused = null;

  function openDrawer(systemId) {
    var template = grid.querySelector('template[data-system-panel="' + systemId + '"]');
    if (!template) return;

    panelTarget.innerHTML = '';
    panelTarget.appendChild(template.content.cloneNode(true));
    panelTarget.scrollTop = 0;

    lastFocused = document.activeElement;
    drawer.hidden = false;
    // allow the browser to paint hidden->block before animating in
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      drawer.hidden = true;
      panelTarget.innerHTML = '';
      if (lastFocused) lastFocused.focus();
    }, 300);
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openDrawer(trigger.getAttribute('data-system-id'));
    });
  });

  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });
});
